import PageLoader from "../../common/controls/pageloader";
import organizersService from "../../../services/organizersService";
import manageOrganizers from "../manageorganizers";
import moment from "moment";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "organizers",
  components: { PageLoader, manageOrganizers, pageheader },
  props: [],
  data() {
    return {
      input: {},
      showloadingSection: false,
      addOrganizerPayLoad: {},
      showManageOrganizersModal: false,
      counterKey: 0,
      action: null,
      edititem: null,
      search: "",
      sortBy: "createdDate",
      sortDesc: true,
      headers: [
        {
          text: "First Name",
          align: "left",
          sortable: true,
          value: "firstName"
        },
        {
          text: "Last Name",
          sortable: true,
          value: "lastName"
        },
        {
          text: "Phone",
          sortable: true,
          value: "phone"
        },
        {
          text: "Email",
          sortable: true,
          value: "email"
        },

        {
          text: "Created",
          sortable: true,
          value: "createdDate"
        },
        { text: "Actions", value: "actions", sortable: false }
      ],
      organizers: [],
      pagination: {
        // sortBy: "createdDate",
        // rowsPerPage: 5,
        // descending: true
      },
      page: 1,
      openedPanel: [],
      isExpanded: false,
      showbanner:true
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatDate: function(value) {
      if (value != "" && value != null && value != undefined) {
        return moment(String(value)).format("MM/DD/YYYY");
      } else {
        return "";
      }
    },
    formatMonth: function(value) {
      if (value != "" && value != null && value != undefined) {
        return moment(String(value), "MM").format("MMM");
      } else {
        return "";
      }
    },
    formatAmount(value) {
      if (value != "" && value != null && value != undefined) {
        value = Math.round(value * 100) / 100;
        return (
          "$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      } else {
        return "$0";
      }
    },
    lowercase: function(value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    pages() {
      var datatable = this.$refs.table;
      if (datatable && typeof datatable != "undefined") {
        return this.pagination.rowsPerPage
          ? Math.ceil(datatable.itemsLength / this.pagination.rowsPerPage)
          : 0;
      }

      return this.pagination.rowsPerPage
        ? Math.ceil(this.organizers.length / this.pagination.rowsPerPage)
        : 0;
    }
  },
  created() {
    //when an organizer is created in manageorganizers component refresh this component
    this.$eventHub.$on("organizerCreated", () => {
      //show loader
      this.showloadingSection = true;
      this.getOrganizers();
    });
  },
  mounted() {
    this.input = utils.getInputContent("organizers", this.roles);
    this.showloadingSection = true;
    this.getOrganizers();
  },
  methods: {
    getOrganizers() {
      organizersService.getOrganizers(
        this,
        data => {
          if (data) {
            this.organizers = data;
          }
          this.showloadingSection = false;
        },
        error => {
          console.log(error);
          this.showloadingSection = false;
        }
      );
    },
    addOrganizerClick() {
      this.forceRerender();
      this.action = "add";
      this.showManageOrganizersModal = true;
    },
    editItem(item) {
      console.log(item);
      this.forceRerender();
      this.action = "update";
      this.edititem = item;
      this.showManageOrganizersModal = true;
    },
    deleteItem(item) {
      console.log(item);
    },
    forceRerender() {
      this.counterKey += 1;
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
  }
};
